import { ObservableFromFetch } from "../ObservableFromFetch"
import ServiceType from "./Model/ServiceType"
import Service from "./Model/Service"
import AccountService from "./Model/AccountService"

export default function ServicesGet() {
  return ObservableFromFetch<Service[]>("WorkforceService/GetServices")
}

export function ServiceTypesGet() {
  return ObservableFromFetch<ServiceType[]>("WorkforceService/GetServiceTypes")
}

export function AccountServicesGet(implementationID: number, accountID?: number) {
  var body: {ImplementationID: string, AccountID?: string} =  { ImplementationID: implementationID.toString(), AccountID: "0" } 
  if (accountID) body.AccountID = accountID.toString()
  const requestBody = JSON.stringify(body);
  return ObservableFromFetch<AccountService[]>("WorkforceService/GetAccountServices", requestBody )
}


export interface SaveService {
  ServiceID: number
  ActiveWorkForce: boolean
  ActivateAll: boolean
}

export interface SaveAccountService {
  AccountServiceID?: number
  Active: boolean
  ServiceID: number
}

export interface SaveServices {
  Services: SaveService[]
  AccountServices: SaveAccountService[]
  AccountID?: number
  ImplementationID?: number
}

export function AccountServicesSave(data: SaveServices) {
  const requestBody: string = JSON.stringify(data)

  return ObservableFromFetch<string>("WorkforceService/UpdateServices", requestBody )
}